import React from 'react';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

type Props = {
  color?: string;
  marginVertical?: number;
  marginHorizontal?: number;
  style?: StyleProp<ViewStyle>;
};

export const SeparatorHorizontal: React.FC<Props> = ({
  color,
  marginVertical,
  marginHorizontal,
  style,
}) => (
  <View
    style={[
      {
        backgroundColor:
          color ||
          (Platform.OS === 'ios' ? 'rgba(0,0,0,.1)' : 'rgba(0,0,0,.04)'),
        height: Platform.OS === 'ios' ? StyleSheet.hairlineWidth : 1,
        marginVertical,
        marginHorizontal,
      },
      style,
    ]}
  />
);
